import type {RefObject} from 'react';
import type {AiGeneratedContent} from '@Components/ai-text-prompt-box/ai-text-prompt-box.types';
import type {SocialPlatform} from '@Components/social-media/social-media.types';

export const CAPTION_WRITER_PROMPT_BOX_ID = 'social-caption-writer-prompt-box';
export const CAPTION_WRITER_SESSION_STORAGE_KEY = 'social-captions-writer-data';
export const CAPTION_WRITER_USED_IDS_SESSION_STORAGE_KEY = 'social-captions-writer-used-caption-ids';
export const CAPTION_WRITER_CONTEXTUAL_MENU_WIDTH = 300;

export interface CaptionWriterPopoverViewProps {
  isOpen: boolean;
  referenceElementRef: RefObject<HTMLButtonElement | null>;
  accountId: number;
  accountType: SocialPlatform;
  postId: string;
  onClose: () => void;
  onContentSelected: (item: AiGeneratedContent) => void;
}
